import type { Catalog } from "../../en";

/** Filipino: platform admin audit screen (mirrors en). */
export const audit: Catalog["adminScreens"]["audit"] = {
  title: "Mga audit log",
  subtitle: "Bawat privileged na aksyon ng CRUD.IT staff, tenant admin at system job sa buong platform.",
  verify: "I-verify ang hash chain",
  export: "I-export",
  exportCsv: "CSV (kasalukuyang filter)",
  exported: "Na-download ang audit export · {{file}}",
  integrity: {
    title: "Append-only · hashed chain.",
    body: "Hindi mae-edit o mabubura ang mga entry. Bawat row ay may sha256(prev_hash ‖ payload), kaya masisira ang chain sa anumang pagbabago; kinukuwenta itong muli ng Verify para sa napiling saklaw.",
    unverified: "Hindi pa na-verify",
    verifying: "Vine-verify…",
    intact: "Buo ang chain",
    broken: "Sira ang chain",
    verified: "Na-verify ang {{formatted}} event · buo ang {{scope}} chain",
    brokenToast: "Sira ang hash chain sa event #{{seq}} — i-escalate sa security",
    platformScope: "platform",
    tenantScope: "tenant",
  },
  scope: {
    label: "Chain",
    all: "Lahat ng event",
    platform: "Platform chain",
    tenant: "Tenant chain",
    tenantPicker: "Tenant",
    pickTenant: "Pumili ng tenant…",
  },
  filters: {
    search: "Hanapin ang actor, aksyon, target, IP…",
    searchLabel: "Maghanap ng audit event",
    actorLabel: "Uri ng actor",
    actors: { all: "Lahat ng actor", staff: "Staff", tenant: "Tenant", system: "Sistema" },
    categoryLabel: "Kategorya",
    allCategories: "Lahat ng kategorya",
    rangeLabel: "Saklaw ng oras",
    ranges: { "24h": "Huling 24 oras", "7d": "Huling 7 araw", "30d": "Huling 30 araw", all: "Lahat ng oras", custom: "Custom na saklaw…" },
    from: "Mula",
    to: "Hanggang",
  },
  categories: {
    impersonation: "Impersonation",
    tenants: "Mga tenant",
    plans: "Mga plano",
    billing: "Billing",
    developer: "Mga API key",
    models: "Mga model at routing",
    staff: "Staff at access",
    security: "Seguridad",
    knowledge: "Kaalaman",
    agents: "Mga agent",
    settings: "Mga setting",
    system: "Sistema",
    support: "Suporta",
    audit: "Audit",
    admin: "Mga pagbasa ng admin",
  },
  table: {
    colTime: "Oras (PHT)",
    colActor: "Actor",
    colRole: "Tungkulin",
    colAction: "Aksyon",
    colTarget: "Target",
    colIp: "IP",
    colDetails: "Detalye",
    details: "Detalye",
    detailsFor: "Detalye ng {{action}} noong {{time}}",
    actorTypes: { staff: "Staff", tenant: "Tenant", system: "Sistema", end_user: "End user", api_key: "API key" },
    unknownActor: "Hindi kilala",
    showing_one: "Ipinapakita ang {{count}} event",
    showing_other: "Ipinapakita ang {{count}} event",
    page: "Pahina {{page}}",
    newer: "Mas bago",
    older: "Mas luma",
    emptyTitle: "Walang tugmang event",
    emptyBody: "Subukan ang mas malawak na saklaw ng oras o i-clear ang mga filter.",
    clearFilters: "I-clear ang mga filter",
  },
  sheet: {
    loading: "Nilo-load ang event…",
    actor: "Actor",
    target: "Target",
    ip: "IP address",
    category: "Kategorya",
    impersonatedBy: "In-impersonate ni",
    change: "Pagbabago (JSON diff)",
    noChange: "Walang naitalang pagbabago ng field para sa event na ito.",
    diffLabel: "JSON diff ng pagbabago",
    copy: "Kopyahin ang diff",
    copied: "Nakopya ang diff",
    integrity: "Integridad",
    eventId: "event_id",
    hashesNote: "Nakatala ang hash, nakaraang hash, user agent at trace kasama ng event pero hindi pa inilalabas ng API.",
    moreFromActor: "Iba pa mula sa actor na ito",
    done: "Tapos",
  },
};
